import { render, staticRenderFns } from "./featuredItem.vue?vue&type=template&id=ee1e7920&scoped=true&"
import script from "./featuredItem.vue?vue&type=script&lang=js&"
export * from "./featuredItem.vue?vue&type=script&lang=js&"
import style0 from "./featuredItem.vue?vue&type=style&index=0&id=ee1e7920&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1e7920",
  null
  
)

export default component.exports